import { useState, useEffect } from 'react';

// Utility to detect if the user is on a mobile device
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768; // Mobile breakpoint
};

// Hook to detect screen size changes
export const useIsMobile = () => {
  if (typeof window === 'undefined') return false;
  
  const [isMobile, setIsMobile] = useState(isMobileDevice);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return isMobile;
};

